export default function recall( btn, blog ) {
	$( btn ).on( 'click', function( e ) {
		e.preventDefault();
		let nextBtn = $( this );
		let next_page = nextBtn.attr( 'href' );

		$( '<div id="articles2" style="display: none">' ).load( next_page + ' ' + blog, function() {
			$( '#articles' ).append( this );
			let articleNew = $( '#articles2' )[0];
			articleNew.replaceWith( ...articleNew.childNodes );

			nextBtn.parent().load( next_page + ' ' + btn, function() {
				recall( btn, blog );
			} );
		} );
	} );
}
